// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1e7918af","453":"f94a26c1"}[chunkId] + ".chunk.js";
};